if (!customElements.get("m-slideshow-tcw")) {
    class MSlideshow extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.autoplay = this.dataset.autoplay === "true";
            this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
            this.showArrows = this.dataset.enableArrows === "true";
            this.showDots = this.dataset.enableDots === "true";
            this.adaptHeight = this.dataset.slideHeight === "adapt";
            this.id = this.dataset.id;
            this.sliderContainer = this.querySelector(".swiper-container");

            this.initSlider();
           
        }

        initSlider() {
            this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
                init: false,
                autoplay: this.autoplay ? {
                    delay: this.autoplaySpeed * 1000,
                    disableOnInteraction: true,
                } : false,
                slidesPerView: 1,
                slidesPerGroup: 1,
                disableOnInteraction: true,
                loop: true,
                speed: 1000, // Transition speed in milliseconds
                navigation: this.showArrows ? {
                    nextEl: this.querySelector(".m-slider-controls__button-next"),
                    prevEl: this.querySelector(".m-slider-controls__button-prev"),
                } : false,
                pagination: this.showDots ? {
                    el: this.querySelector(".swiper-pagination"),
                    clickable: true,
                    bulletClass: "m-dot",
                    bulletActiveClass: "m-dot--active",
                } : false,
                breakpoints: {
                    992: {
                        threshold: 2,
                    },
                },
                on: {
                    init: () => {
                        setTimeout(() => {
                            window.dispatchEvent(new Event("resize"));
                        }, 100);
                    },
                },
            });

            this.slider && this.slider.on("init", this.handleChange.bind(this));
            this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
            this.slider.init();
        }

       

     handleChange(swiper) {
            const { activeIndex, slides, previousIndex } = swiper;
            const totalSlides = slides.length;
            const activeSlide = slides[activeIndex];
            const previousSlide = slides[previousIndex];
            const isNext = activeIndex > previousIndex || (activeIndex === 0 && previousIndex === totalSlides - 1);
            const isPrev = activeIndex < previousIndex || (activeIndex === totalSlides - 1 && previousIndex === 0);
        
            if (!activeSlide || !previousSlide) return;
        
            const applyAnimation = (elements, animationClass, removeClass = true) => {
                elements.forEach((element) => {
                    element.classList.add(animationClass);
                    if (removeClass) {
                        element.addEventListener("animationend", () => {
                            element.classList.remove(animationClass);
                        }, { once: true });
                    }
                });
            };
        
            if (isNext) {
                // Apply out animations to the previous slide
                applyAnimation(previousSlide.querySelectorAll(".wave_right_holder"), "slide-out-animation-right");
                applyAnimation(previousSlide.querySelectorAll(".wave_left_holder"), "slide-out-animation-left");
                applyAnimation(previousSlide.querySelectorAll(".tcw-can-title"), "text-out-animation");
                applyAnimation(previousSlide.querySelectorAll(".tcw-can-element-in"), "can-out-animation");
        
                // Apply in animations to the active slide
                applyAnimation(activeSlide.querySelectorAll(".wave_right_holder"), "slide-in-animation-right");
                applyAnimation(activeSlide.querySelectorAll(".wave_left_holder"), "slide-in-animation-left");
                applyAnimation(activeSlide.querySelectorAll(".tcw-can-title"), "text-in-animation");
                applyAnimation(activeSlide.querySelectorAll(".tcw-can-element-in"), "can-in-animation");
               applyAnimation(activeSlide.querySelectorAll(".animate-color-changes"), "animate-color-change");
            }
        
            if (isPrev) {
                // Apply out animations to the previous slide
                applyAnimation(previousSlide.querySelectorAll(".wave_right_holder"), "slide-out-animation-left");
                applyAnimation(previousSlide.querySelectorAll(".wave_left_holder"), "slide-out-animation-right");
                applyAnimation(previousSlide.querySelectorAll(".tcw-can-title"), "text-out-animation");
                applyAnimation(previousSlide.querySelectorAll(".tcw-can-element-in"), "can-out-animation-left");
        
                // Apply in animations to the new active slide
                applyAnimation(activeSlide.querySelectorAll(".wave_right_holder"), "slide-in-animation-right");
                applyAnimation(activeSlide.querySelectorAll(".wave_left_holder"), "slide-in-animation-left");
                applyAnimation(activeSlide.querySelectorAll(".tcw-can-title"), "text-in-animation");
                applyAnimation(activeSlide.querySelectorAll(".tcw-can-element-in"), "can-in-animation");
                 applyAnimation(activeSlide.querySelectorAll(".animate-color-changes"), "animate-color-change");
            }
        }




      

    }

    customElements.define("m-slideshow-tcw", MSlideshow);
}
